class MastheadNavigation extends HTMLElement {
  constructor() {
    super();

    this.state = {
      open: false,
      openMenu: null
    };
    this.summaryElements = this.querySelectorAll('summary:not(.accordion-summary)');
    this.bindListeners();
  }

  bindListeners() {
    this.summaryElements.forEach((element) => {
      element.addEventListener('click', this.onClick.bind(this, element));
    });

    document.addEventListener('click', this.clickOutSide.bind(this))
    document.body.addEventListener('keyup', this.onKeyUpEscape.bind(this));
  }

  onClick(element, event) {
    const id = element.getAttribute('id');

    if (!this.state.open) {
      this.menuOpen(id);
    } else if (this.state.openMenu === id) {
      this.menuClose();
    } else if (id) {
      this.menuOpen(id);
    }
  }

  onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.returnFocus(this.state.openMenu);
    this.menuClose();
  }

  menuOpen(id) {
    this.state.open = true;
    this.state.openMenu = id;
    document.body.classList.add('overlay');
  }

  menuClose() {
    this.state.open = false;
    this.state.openMenu = null;
    document.body.classList.remove('overlay');
  }

  menuItemFocusOut(id) {
    if (this.state.openMenu === id && this.state.open) {
      this.menuClose();
    }
  }

  returnFocus(id) {
    if (id) {
      const summary = this.querySelector(`#${id}`);
      summary.focus();
    }
  }

  clickOutSide(event) {
    if (!event.target.closest('masthead-navigation')) {
      this.menuClose();
    }
  }
}

customElements.define('masthead-navigation', MastheadNavigation);
